<template>
    <CenterBox>
        <h3 class="error-text">Permission Denied</h3>
        <p>You don't have permission to access this page, please try other pages or contact your administrator.</p>
    </CenterBox>
</template>

<script>
import CenterBox from "@/components/routerViewLocation/CenterBox";
export default {
    name: "ErrorNoPermissionPageView",
    components: {CenterBox}
}
</script>

<style scoped>

</style>
